import React, { useState } from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { CampaignParticipantProps, PublicPlayerProps } from "../../types"
import { FlatList, Image } from 'react-native';
import { useColors } from '../../constants/useColors';
import moment from 'moment-mini';

type CampaignParticipantListProps = {
    campaign_participants:CampaignParticipantProps[],
    players:PublicPlayerProps[],
    selected_participant?:string,
    horizontal?:boolean,
    onSelect:(cp:CampaignParticipantProps) => void,
    onDeselect: (cp:CampaignParticipantProps) => void

}

const ParticipantsList = ({ campaign_participants, players, selected_participant, horizontal, onSelect, onDeselect }:CampaignParticipantListProps) => {
    const [ participant_page ] = useState(1);
    const Colors = useColors();
    const visible_participants = campaign_participants.sort((a,b) => a.status.localeCompare(b.status) || moment(b.create_datetime).unix() - moment(a.create_datetime).unix()).slice((participant_page-1) * 5, ((participant_page-1) * 5) + 5)

    const renderParticipants = (data:{ item:CampaignParticipantProps, index:number }) => {
        const player = players.find(p => p.player_id == data.item.player_id);
        const active = data.item.status == 'active' ? true : false
        if(!player){ return <></> }
        const selected = data.item.campaign_participant_id == selected_participant ? true : false
        return (
            <Button float 
            style={{ flexDirection:horizontal?'column':'row', alignItems:'center', borderRadius:100, margin:8, padding:2, borderWidth:selected || active?2:0, borderColor:selected?Colors.text.action:active?Colors.text.success:'transparent' }}
            onPress={() => selected ? onDeselect(data.item) : onSelect(data.item)}>
                <Image
                    source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:50, width:50, borderRadius:100 }}
                />
                {!horizontal ?
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h2'>@{player.username}</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Visited {moment(data.item.last_update_datetime).fromNow()}</Text>
                </View>
                :<></>}
            </Button>
        )
    }

    return (
        <View style={{ flex:1 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View transparent style={{ flex:1, marginRight:10 }}>
                    <Text theme='h1'>Participants</Text>
                    <Text theme='description' style={{ marginTop:4 }}>Check out who is participating here!</Text>
                </View>
                <View transparent style={{ justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1' color={Colors.text.action}>{campaign_participants.length}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>Participants</Text>
                </View>
            </View>
            <FlatList
                data={visible_participants}
                renderItem={renderParticipants}
                horizontal={horizontal}
                key={'campaign_particpant_list'}
                keyExtractor={(item) => item.campaign_participant_id.toString()}
            />
        </View>
    )
}

export default ParticipantsList